import { handleResponse } from '@/services/handleresponse'

const API_URL = "https://api.irmastore.id"
// const API_URL = "http://localhost:8081"

export const SidompulService = {
  getSidompulUrl,
  updateUrlModuleSidompul
}

function getSidompulUrl () {
  return fetch(API_URL + "/api/v1/sidompul", {
    method: "GET",
    headers: { 
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
  .then(data => {
    return data
  })
}

function updateUrlModuleSidompul(data){
  return fetch(API_URL + "/api/v1/sidompul", {
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(data)
  }).then(handleResponse)
  .then(data => {
    return data
  })
}